import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize, Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import PropertyCzNotes from './propertyCzNotes';

import './propertyCz.scss';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

class PropertyCzParcelBuilding extends React.Component {
    state = {
        expanded: false
    };

    static propTypes = {
        onParcel: PropTypes.object.isRequired,
        parts: PropTypes.array.isRequired,
        ownershipData: PropTypes.object.isRequired
    };

    render() {
        const { onParcel, parts, ownershipData } = this.props;
        const filteredParts = parts.filter(f => !isNullOrUndefined(f.id));
        const hasBuilding = !isNullOrUndefined(onParcel.id) || filteredParts.length > 0;

        if (hasBuilding) {
            return (<>
                <div>
                    <span onClick={() => this.setState({ expanded: !this.state.expanded })} className="link-internal">
                        <Translate id="PropertyCz.Report.BuildingIncluded" />
                    </span>
                </div>
                {!isNullOrUndefined(onParcel.id) && this.state.expanded && this.renderDetail(onParcel, ownershipData)}
                {this.state.expanded && filteredParts.map(p => this.renderDetail(p, ownershipData))}
            </>);
        }
        else {
            return null;
        }
    }

    renderDetail = (data, ownershipData) => {
        return (
            <OldStyleTableWithHistory key={data.id} fixed classNames='old-style-bordered'
                colWidths={['25%','25%','25%','25%']}
                actualData={[1,2,3,4,5,6,7]}
                actualRow={p => <>
                    {p == 1 && <tr>
                        <th><Translate id="PropertyCz.Report.OD.HouseNo" /></th>
                        <td>{data.houseNo}</td>
                        <th><Translate id="PropertyCz.Report.OD.BuildingNo" /></th>
                        <td>{data.id}</td>
                    </tr>}{p == 2 && <tr>
                        <th><Translate id="PropertyCz.Report.OD.OwnershipDeed" /></th>
                        <td>{data.ownershipDocumentId}</td>
                        <th><Translate id="PropertyCz.Report.OD.OnParcelNo" /></th>
                        <td>{data.parcelNumbers}</td>
                    </tr>}{p == 3 && <tr>
                        <th style={{ width: '7.5em' }}><Translate id="PropertyCz.Report.CU.CadastreUnitName" /></th>
                        <td>{data.cadastreUnitName}</td>
                        <th><Translate id="PropertyCz.Report.CU.MunicipalityName" /></th>
                        <td>{data.municipality}</td>
                    </tr>}{p == 4 && <tr>
                        <th><Translate id="PropertyCz.Report.OD.Owner" /></th>
                        <td>{ownershipData.ownerName}</td>
                        <th><Translate id="PropertyCz.Report.OD.Address" /></th>
                        <td>{ownershipData.ownerAddress}</td>
                    </tr>}{p == 5 && <tr>
                        <th><Translate id="PropertyCz.Report.OD.Share" /></th>
                        <td colSpan={3}>{ownershipData.share}</td>
                    </tr>}{p == 6 && <tr>
                        <th><Translate id="PropertyCz.Report.OD.Usage" /></th>
                        <td>{data.usage}</td>
                        <th><Translate id="PropertyCz.Report.OD.ProtectionType" /></th>
                        <td style={{wordBreak:'break-word'}}>{data.protection}</td>
                    </tr>}{p == 7 && <tr>
                        <td colSpan={4}>
                            <PropertyCzNotes notes={data.ownershipRestrictions} restrictions />
                            <PropertyCzNotes notes={data.notes} />
                        </td>
                    </tr>}
                </>}
            />
        );
    }
}

export default withLocalize(PropertyCzParcelBuilding);